import React, { useEffect, useState } from "react";
import { Box, TextField, IconButton, InputAdornment } from "@mui/material";
import BaseDrawer from "../../UI/BaseDrawer/BaseDrawer";
import BaseButton from "../../UI/BaseButton/BaseButton";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import PinPad from "../../PinPad/PinPad";
import { useSelector } from "react-redux";
import { profileChangePassword } from "../../../util/API/passwordpinchange";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function PasswordChange({ open, handleCloseModal }) {
  const [password, setPassword] = useState("");
  const [retypePassword, setRetypePassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [showPinPad, setShowPinPad] = useState(false);
  const [visible, setVisible] = useState({
    password: false,
    confirmPassword: false,
    currentPassword: false
  })
  const [alert, setAlert] = useState(
    {
      showAlert: false,
      severity: "error",
      header: "",
      message: ""
    }
  )

  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body
  let pin = sessionStorage.getItem("pin");
  const pinConfiguration = useSelector((state) => state.login.pinConfiguration);

  useEffect(() => {
    setPassword("");
    setRetypePassword("");
    setCurrentPassword("");
  }, [open])

  const handleConfirm = (event, pin) => {
    let PIN = pin.join('');
    handleChangePassword(event, PIN);
    setShowPinPad(false);
  };

  const handleChangePassword = async (event, pin) => {
    try {
      const response = await profileChangePassword(
        agent['Useremailaccount'].emailAccount,
        password,
        pin,
        agent['User'].id,
        currentPassword
      )

      if (response?.callStatus === "1") {
        setAlert({
          showAlert: true,
          severity: "success",
          header: "Success",
          message: "Password changed successfully"
        })

        if (pinConfiguration === "once") {
          sessionStorage.setItem("pin", pin);
        }

      }

      else {
        setAlert({
          showAlert: true,
          severity: "error",
          header: "Error",
          message: response?.payload?.msg
        })
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  const handleSaveClick = () => {
    if (!currentPassword || !password || !retypePassword) {
      setAlert({
        showAlert: true,
        severity: "error",
        message: "Please fill in all the fields.",
        header: "Error!",
      });
      return;
    }
    
    if (password !== retypePassword) {
      setAlert({
        showAlert: true,
        severity: "error",
        message: "Password does not match",
        header: "Error!"
      });
      return;
    }
    setShowPinPad(true);
  }

  return (
    <BaseDrawer open={open} handleClose={handleCloseModal} height="80vh" title="Change Password">
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

        <Box
          sx={{
            p: 3,
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: 0.2,
            gap: 2,
            display: "flex",
            flexDirection: "column",
            width: "50%", // Ensures the form is centered and takes up a specific width
            alignItems: "center", // Centers the textfields horizontally
          }}
        >
          <TextField
            label="Current Password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            fullWidth
            variant="outlined"
            InputLabelProps={{
              shrink: true,
              sx: { fontSize: "0.875rem", lineHeight: "1.2" },
            }}
            sx={{
                width: "48%",
                mt: 2
            }}
            type={visible.currentPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setVisible({ ...visible, currentPassword: !visible.currentPassword })
                    }
                  >
                    {visible.currentPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            label="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            variant="outlined"
            InputLabelProps={{
              shrink: true,
              sx: { fontSize: "0.875rem", lineHeight: "1.2" },
            }}
            sx={{
                width: "48%",
                mb: 2,
                mt: 2
            }}
            type={visible.password ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setVisible({ ...visible, password: !visible.password })
                    }
                  >
                    {visible.password ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            label="Retype Password"
            value={retypePassword}
            onChange={(e) => setRetypePassword(e.target.value)}
            fullWidth
            variant="outlined"
            InputLabelProps={{
              shrink: true,
              sx: { fontSize: "0.875rem", lineHeight: "1.2" },
            }}
            sx={{
                width: "48%"
            }}
            type={visible.confirmPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setVisible({
                        ...visible,
                        confirmPassword: !visible.confirmPassword,
                      })
                    }
                  >
                    {visible.confirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <BaseButton 
            buttonText="Save"  
            onClick={(e) => pin ? handleChangePassword(e, pin) : pinConfiguration === "never" ? handleChangePassword(e, '0000') : handleSaveClick()}  
          />
        </Box>
      </Box>

      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        // onClick={() => {setAlert({ ...alert, showAlert: false }); handleCloseModal();}}
        onClick={() => {
          setAlert({ ...alert, showAlert: false });
          if (alert?.severity !== "error") {
            handleCloseModal();
          }
        }}
        autoclose={alert.severity === "error" ? false : true}
      />

      {showPinPad && <PinPad show={showPinPad} handleConfirm={handleConfirm} onClick={() => setShowPinPad(false)} />}

    </BaseDrawer>
  );
}

export default PasswordChange;
